import { render, staticRenderFns } from "./errorPill.vue?vue&type=template&id=ac2688be&"
import script from "./errorPill.vue?vue&type=script&lang=js&"
export * from "./errorPill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports